import script from "./sideNav.vue?vue&type=script&setup=true&lang=js"
export * from "./sideNav.vue?vue&type=script&setup=true&lang=js"

import "./sideNav.vue?vue&type=style&index=0&id=3d6af604&lang=less&scoped=true"

import exportComponent from "E:\\Voyager_Project\\SourceCode\\Front_End\\dev_version_Voyager\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6af604"]])

export default __exports__